module.exports = __webpack_public_path__ + "img/booking-channel.5eac0f40.svg";